module.exports = __webpack_public_path__ + "img/cubus_logo_v5.9bbd91cf.svg";